<template>
    <v-snackbar v-model="show"
                multi-line
                right
                :timeout="5000"
                :color="color">
        {{ message }}
        <template>
            <v-btn dark
                   text
                   @click="show = false">
                Close
            </v-btn>
        </template>
        <!--<v-btn @click="show = false">Close</v-btn>-->
    </v-snackbar>
</template>
<script>
    import { mapState } from 'vuex';

    export default {
        data() {
            return {
                show: false,
                message: '',
                color: ''
            }
        },
        computed: mapState({
            isError: state => state.AppStore.isError
        }),
        methods: {
            getColor() {
                if (this.isError) return "error";
                else return "success";
            }
        },
        created() {
            this.$store.watch(state => state.AppStore.alert, () => {
                const msg = this.$store.state.AppStore.alert
                const isError = this.$store.state.AppStore.isError
                if (msg !== '') {
                    this.show = true
                    this.message = this.$store.state.AppStore.alert
                    if (isError) {
                        this.color = 'red'
                    }
                    else {
                        this.color = 'success'
                    }
                    this.$store.commit('AppStore/setAlert', { alert: '', isError: false });
                    //this.$store.commit('AppStore/setAlert', { alert: '', isError: false })
                }
            })
        }
    }
</script>
